import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import React from 'react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

interface BestValueProps extends HTMLAttributes<HTMLDivElement> {}

const BestValue: FunctionComponent<BestValueProps> = ({...attributes}) => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  return (
    <div {...attributes}>
      <div className="relative rounded-lg border border-[#84CC16] bg-[#F6FFEC] px-2 py-0.5 text-sm text-[#84CC16]">
        {translations.Badge.bestValue}
      </div>
    </div>
  )
}
export default BestValue
